import React, { useState } from "react";
import { Modal, Input } from "antd";
import dayjs from "dayjs";

import useUpdate from "hooks/useUpdate";
import range from "helpers/range";
import TaskColorPicker from "components/TaskColorPicker";
import InputDate from "components/InputDate";

const disabledDateTime = () => ({
  disabledMinutes: () => [
    ...range(1, 15),
    ...range(16, 30),
    ...range(31, 45),
    ...range(46, 60),
  ],
});

const EditTask = ({ id, refetch, initial_values, handleClose }) => {
  const [content, setContent] = useState(initial_values.content);
  const [date, setDate] = useState(initial_values.date);
  const [status_color, setStatusColor] = useState(initial_values.status_color);

  const { is_saving, updateAsync } = useUpdate({
    path: `/tasks/${id}`,
    onSuccess: refetch,
  });

  const is_dirty =
    initial_values.content !== content ||
    initial_values.status_color !== status_color ||
    initial_values.date !== date;

  const handleOk = async () => {
    try {
      await updateAsync({
        content,
        status_color,
        date
      });
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      style={{ top: 45 }}
      maskClosable={false}
      width={700}
      title="Edytuj priorytet"
      open={true}
      onOk={handleOk}
      onCancel={handleClose}
      cancelText="Anuluj"
      okText="Zapisz"
      okButtonProps={{
        disabled: !content || is_saving || !is_dirty,
        loading: is_saving,
      }}
    >
      <Input.TextArea
        value={content}
        style={{ marginBottom: 20 }}
        onChange={({ target: { value } }) => setContent(value)}
        rows={7}
        maxLength={400}
        showCount={true}
      />
      <InputDate
        format="DD-MM-YYYY HH:mm"
        showTime={{ format: "HH:mm" }}
        disabledTime={disabledDateTime}
        defaultValue={dayjs(date)}
        onChange={(a) => setDate(a)}
      />
      <TaskColorPicker active_color={status_color} setColor={setStatusColor} />
    </Modal>
  );
};

export default EditTask;
